<div id="teacher-classes-index" class="container margin-top-1">
  <ng-template #noDataStudents>
    <div class="flex-center">
      {{ "no-students-yet" | translate }}
    </div>
  </ng-template>

  <ng-container *ngIf="students.length; else noDataStudents">
    <mat-expansion-panel class="margin-top-1 margin-bottom-1" *ngFor="let student of students; index as index">
      <mat-expansion-panel-header collapsedHeight="80px" class="black">
        <div class="flex-start">
          <div>
          <img [src]="student.profile_photo_path" class="classes-image margin-top-1 margin-bottom-1"
            *ngIf="student.profile_photo_path" appErrorImage />
          </div> 

          <div class="classes-name">
            {{ student.name }}
          </div>

          <div class="margin-right-1 hours-left-buyed-text" *ngIf="student.hours_left==0">
              Sin horas.
          </div>
          <div class="margin-right-1 hours-left-buyed-text" *ngIf="student.hours_left!=0">
            {{
            "hours-left-buyed"
            | translate: "{hours:" + student.hours_left + "}"
            }}
          </div>

          <mat-icon class="class-icon gray cursor-pointer"
            (click)="onChatStudent(student); $event.stopPropagation()">
            chat
          </mat-icon>
          <mat-icon class="class-icon gray cursor-pointer"
            (click)="showStudentInfo(student); $event.stopPropagation()">
            info
          </mat-icon>
        </div>
      </mat-expansion-panel-header>
      <mat-paginator [pageSize]="15" *ngIf="student.classes_count" [pageIndex]="student.paginate"
        (page)="onChangePage($event, index)" [length]="student.classes_count">
      </mat-paginator>

      <table mat-table [dataSource]="student.classes">
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- student Column -->
        <ng-container matColumnDef="lesson_name">
          <th mat-header-cell *matHeaderCellDef class="table-header">
            {{ "lesson" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div>
              {{ element.lesson_name }}
            </div>
          </td>
        </ng-container>

        <!-- date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>{{ "date" | translate }}</th>
          <td mat-cell *matCellDef="let element">{{ element.date }}</td>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ "status" | translate }}</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{
              'text-pendent': element.state == 0,
              'text-accepted': element.state == 1,
              'text-rejected': element.state == 3
            }">
            {{ "status-" + element.state | translate }}
          </td>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th class="text-center" mat-header-cell *matHeaderCellDef>
            <span *ngIf="!isMobile">{{ "actions" | translate }}</span>
          </th>
          <td class="text-center" mat-cell *matCellDef="let element">
            <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="[0, 1, 3, 4].includes(element.state)">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button *ngIf="[0, 1].includes(element.state)" mat-menu-item
                (click)="onActionClass(element, index, 'cancel')">
                <mat-icon>block</mat-icon>
                <span>{{ "cancel" | translate }}</span>
              </button>

              <button *ngIf="[0, 1].includes(element.state)" mat-menu-item
                (click)="onActionClass(element, index, 'reschedule')">
                <mat-icon>event_available</mat-icon>
                <span>{{ "reschedule" | translate }}</span>
              </button>

              <button *ngIf="[0, 1, 3, 4].includes(element.state)" mat-menu-item
                (click)="onActionClass(element, index, 'report-incident')">
                <mat-icon>notifications</mat-icon>
                <span>{{ "report-incident" | translate }}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <!-- duration Column -->
        <ng-container matColumnDef="duration">
          <th class="text-center" mat-header-cell *matHeaderCellDef class="table-header">
            {{ "duration" | translate }} {{ "minutes-abreviation" | translate }}
          </th>
          <td class="text-center" mat-cell *matCellDef="let element">
            <div>
              {{ [2].includes(element.state) ? element.duration_teacher : 60 }}
            </div>
          </td>
        </ng-container>

        <!-- income Column -->
        <ng-container matColumnDef="income">
          <th mat-header-cell *matHeaderCellDef class="table-header">
            {{ "income" | translate }} (€)
          </th>
          <td mat-cell *matCellDef="let element">
            <div>
              {{ element.income | currency: "EUR" }}
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-expansion-panel>
  </ng-container>
</div>